/**
 * Preference filter Menu with slider
 */

import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Slider,
  SliderMark,
  SliderThumb,
  SliderTrack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { defaultPreferenceScore, SlideMarkValues } from "config/Consts";
import _ from "lodash";
import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { jobPayloadState, savedJobPayloadState } from "_state/atoms/AppAtoms";
import { SecondaryButton } from "../HJSButton";

const SliderMarkProps = Object.freeze({
  fontSize: [16, 16, 16, 20],
  fontWeight: "700",
  color: "white",
  mb: -3,
  ml: 8,
});

const PreferenceMenu: FC<{ index?: number }> = ({ index }) => {
  const [value, setValue] = useState<number>(defaultPreferenceScore);
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";

  const [payload, setPayload] = useRecoilState(jobPayloadState);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const getPayload = isJobSearch ? payload : savedJobPayload;
  const setUpdatePayload = isJobSearch ? setPayload : setSavedJobPayload;

  useEffect(() => {
    setValue(getPayload?.preferenceScore ?? defaultPreferenceScore);
  }, [getPayload?.preferenceScore]);

  // console.log("payload : ", getPayload);

  return (
    <Menu
      matchWidth={true}
      closeOnSelect={false}
      onClose={() =>
        setValue(getPayload?.preferenceScore ?? defaultPreferenceScore)
      }
    >
      {({ isOpen, onClose }) => (
        <>
          <MenuButton
            as={SecondaryButton}
            borderLeft="2px solid white"
            borderRadius="initial"
            rightIcon={
              isOpen ? (
                <ChevronUpIcon className="fill-white" />
              ) : (
                <ChevronDownIcon className="fill-white" />
              )
            }
            maxHeight="1.5rem"
            width={44}
          >
            <Text color="white">Preference</Text>
          </MenuButton>
          <MenuList
            backgroundColor="teal.600 !important"
            color="white"
            border="none"
            minW="initial"
            py={4}
          >
            <MenuItem
              backgroundColor="teal.600 !important"
              fontSize="md"
              fontWeight="semibold"
              _hover={{ backgroundColor: "teal.600 !important" }}
              // _focus={{ backgroundColor: "teal.600" }}
              p="initial"
            >
              <VStack spacing={6} px={4} pt={4} align="flex-start">
                <Slider
                  aria-label="preference score"
                  orientation="vertical"
                  minH="25vh"
                  size="lg"
                  value={value}
                  min={1}
                  max={99}
                  onChange={(value) => setValue(value)}
                >
                  {SlideMarkValues.map((value, idx) => (
                    <SliderMark
                      key={_.uniqueId("slider_mark_")}
                      value={value}
                      {...SliderMarkProps}
                      // mb={idx === SlideMarkValues.length - 1 ? -4 : "initial"}
                    >
                      {value}
                    </SliderMark>
                  ))}

                  <SliderTrack bg="hjsSliderTrack">
                    {/* <SliderFilledTrack bg="white" /> */}
                  </SliderTrack>
                  <SliderThumb />
                </Slider>
                <Text fontSize="1rem" fontWeight="500" color="white">
                  Show jobs scored {value} or above
                </Text>
              </VStack>
            </MenuItem>
            <Flex justifyContent="center">
              <Button
                bgColor="transparent !important"
                border="2px solid white"
                color="white"
                mt={3}
                onClick={() => {
                  setUpdatePayload((prev: any) => ({
                    ...prev,
                    preferenceScore: value,
                    page: 1,
                  }));
                  onClose();
                }}
                className="hover:opacity-90"
              >
                Filter
              </Button>
            </Flex>
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default PreferenceMenu;
